import { ReactNode } from 'react';
import classes from './RealEstateCardHighlightedField.module.css';

interface RealEstateCardHighlightedFieldProps {
  label: string;
  inputElement: ReactNode;
}

export const RealEstateCardHighlightedField: React.FC<
  RealEstateCardHighlightedFieldProps
> = ({ label, inputElement }) => {
  return (
    <div className={classes.highlightCard}>
      <p>{label}</p>
      <div>{inputElement}</div>
    </div>
  );
};
